// extracted by mini-css-extract-plugin
module.exports = {"contentIntroduce":"introduce_contentIntroduce_2i3m5"};